interface CoverageSectionProps {
  onWhatsAppClick: () => void;
}

export default function CoverageSection({ onWhatsAppClick }: CoverageSectionProps) {
  const cities = [
    'Blumenau - SC',
    'Indaial',
    'Timbó',
    'Gaspar',
    'Pomerode - SC',
    'Cidades do Vale do Itajaí',
  ];

  return (
    <section id="cobertura" className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">Área de Atuação</h2>
          <p className="text-base md:text-lg text-gray-600">
            Atendimento em Blumenau - SC e região, num raio de até 100 km
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 gap-8 items-center">
          <div>
            <div className="grid grid-cols-1 gap-3">
              {cities.map((city, index) => (
                <div key={index} className="flex items-center bg-white p-3 rounded-lg shadow-md">
                  <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center mr-3">
                    <i className="ri-map-pin-line text-blue-600 text-sm"></i>
                  </div>
                  <span className="text-base font-medium text-gray-800">{city}</span>
                </div>
              ))}
            </div>
          </div>
          
          <div className="bg-white p-6 rounded-2xl shadow-lg">
            <h3 className="text-xl font-bold text-gray-800 mb-4 text-center">Cobertura Regional</h3>
            <p className="text-gray-600 mb-4 leading-relaxed text-sm text-center">
              Oferecemos nossos serviços em toda a região do Vale do Itajaí, com equipamentos de última geração e uma equipe experiente para garantir o sucesso do seu evento.
            </p>
            <div className="flex items-center justify-center text-blue-600 mb-4">
              <i className="ri-phone-line mr-2"></i>
              <span className="font-semibold text-sm">Consulte disponibilidade para sua cidade!</span>
            </div>
            <button 
              onClick={onWhatsAppClick}
              className="w-full bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded-full font-bold transition-colors cursor-pointer whitespace-nowrap text-sm"
            >
              <i className="ri-whatsapp-line mr-2"></i>
              Falar com DJ Jean
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}